export default __webpack_public_path__ + "0b6f42330835928712ea514618d22580.png";